import * as Constants from "../Constants";

import {getAPIIncludeAuth} from "./Shared";

export async function getAllProfessions() {
    const api = Constants.BACKEND_URL + Constants.API_PROFESSION + "?paginationEnabled=false";

    return getAPIIncludeAuth(api);
}
